/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const ControlStatus9 = {
    New: 'NEW',
    Processing: 'PROCESSING',
    Escalated: 'ESCALATED',
    Hunting: 'HUNTING',
    Monitoring: 'MONITORING',
    Chatops: 'CHATOPS',
    Closed: 'CLOSED'
} as const;
export type ControlStatus9 = typeof ControlStatus9[keyof typeof ControlStatus9];


export function ControlStatus9FromJSON(json: any): ControlStatus9 {
    return ControlStatus9FromJSONTyped(json, false);
}

export function ControlStatus9FromJSONTyped(json: any, ignoreDiscriminator: boolean): ControlStatus9 {
    return json as ControlStatus9;
}

export function ControlStatus9ToJSON(value?: ControlStatus9 | null): any {
    return value as any;
}

